import HttpRequestRotoBrain from "../../Services/HttpRequestRotoBrain";


export const getAllArticles = async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: "/v1/articles",
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const getArticleById = async (articleId:string) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: `/v1/articles/${articleId}`,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};



export const getNextArticles = async (currentArticleId:string) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: `/v1/next/articles?currentArticleId=${currentArticleId}`,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const articleEvent = async (currentArticleId:string,body:any) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "POST",
      url: `/v1/articles/${currentArticleId}/events`,
      data : body
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};


export const articleReact = async (articleId:string,body:any) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "POST",
      url: `/v1/articles/${articleId}/react`,
      data : body
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};
